import React, { useState } from "react";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { pageTitle } from "../../helpers/PageTitle";
import { Icon } from "@iconify/react";
import {
  CONTACT_API_URL,
  submitContactForm,
} from "../../helpers/contactFormSubmit";

export default function ContactPage() {
  pageTitle("Contact");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);
    await submitContactForm({
      form: event.currentTarget,
      successTitle: "Successful",
      successText: "Contact form submitted successfully.",
    });
    setIsSubmitting(false);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Get in touch for more <br/>information and support"
        subTitle="Contact"
        shape="shape_6"
      />
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              <h2 className="cs_fs_50">Contact Us</h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Email:</h3>
                  <p className="mb-0">contact@ecomguild.com</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Phone:</h3>
                  <p className="mb-0">+923236625189</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Address:</h3>
                  <p className="mb-0">
                    Plot No. 340, St. 8, Farooq park, Jaranwala, Faisalabad,
                    37250
                  </p>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" />
                <form
                  className="cs_contact_form"
                  method="post"
                  action={CONTACT_API_URL}
                  onSubmit={handleSubmit}
                >
                  <input
                    type="hidden"
                    name="email_to"
                    value="contact@ecomguild.com"
                  />
                  <input
                    type="hidden"
                    name="subject"
                    value="Enquiry Email | Ecom Guild"
                  />
                  <div className="row g-4">
                    <div className="col-md-12">
                      <label className="cs_fs_21 cs_semibold cs_primary_color">
                        Name
                      </label>
                      <input
                        placeholder="Type your name"
                        type="text"
                        name="name"
                        className="cs_form_field"
                        required
                      />
                    </div>
                    <div className="col-md-12">
                      <label className="cs_fs_21 cs_semibold cs_primary_color">
                        Email
                      </label>
                      <input
                        placeholder="Type your email address"
                        type="email"
                        name="email"
                        className="cs_form_field"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label className="cs_fs_21 cs_semibold cs_primary_color">
                        WhatsApp Number
                      </label>
                      <input
                        placeholder="Type your WhatsApp number"
                        type="tel"
                        name="whatsApp"
                        className="cs_form_field"
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="cs_btn cs_style_1"
                        disabled={isSubmitting}
                      >
                        Send Email
                        <span>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                          <i>
                            <Icon icon="fa6-solid:arrow-right" />
                          </i>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="cs_height_0 cs_height_lg_80" />
      </section>
      <div className="cs_map">
        <iframe
          id="map"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d6816.437359134909!2d73.41730559999999!3d31.325333299999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDE5JzMxLjIiTiA3M8KwMjUnMDIuMyJF!5e0!3m2!1sen!2s!4v1772217968580!5m2!1sen!2s"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        />
      </div>
    </>
  );
}
